var map = {
	"./en/404.json": 4014,
	"./en/applyInstitution.json": 9068,
	"./en/crud.json": 7558,
	"./en/downloadIos.json": 1139,
	"./en/downloadOsx.json": 193,
	"./en/errors.json": 4754,
	"./en/info.json": 7718,
	"./en/login.json": 7538,
	"./en/timetable.json": 9610,
	"./en/translation.json": 6207,
	"./ro/404.json": 1308,
	"./ro/applyInstitution.json": 1878,
	"./ro/crud.json": 4849,
	"./ro/downloadIos.json": 6817,
	"./ro/downloadOsx.json": 3868,
	"./ro/errors.json": 6704,
	"./ro/info.json": 7395,
	"./ro/login.json": 5611,
	"./ro/timetable.json": 6213,
	"./ro/translation.json": 3775
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6376;